<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-80 xmlPopup"
          :style="{ 'max-height': getMaxHeightClient() + 'px' }"
          @mousedown="dontClose">
          <div>
            <b-row>
              <b-col style="text-align:end;">
                <i class="fa fa-times close-button" style="font-size:20px" @click="handleMouseDown"></i>
              </b-col>
            </b-row>
          </div>
          <div class="modal-body" style="overflow:auto;" :style="{'max-height' : ((getMaxHeightClient() * 0.85)) + 'px'}">
            <b-container fluid>
              <b-row v-if="isPopupActive">
                <div class="break"><pre lang="xml"><code v-html="highlightedXmlData"></code></pre></div>
              </b-row>
            </b-container>
          </div>
          <div class="modal-footer">
            <b-col lg="2" sm="3" cols="6" class="p-0 m-0">
              <b-button variant="primary" @click="download(xmlDetailsData.data)">{{ $t('common.dwnld') }}</b-button>
            </b-col>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import moment from 'moment'
import backButton from '@/components/common/backButton.vue'
import {downloadFileWithDefinedHeaders} from '@/helpers/download'
import Prism from 'prismjs'
import 'prismjs/themes/prism.css'
import 'prismjs/components/prism-json'
import xmlFormatter from 'xml-formatter'

const { DOMParser } = require('xmldom')

export default {
  name: 'CMXmlDetails',
  components: {
    'back-button': backButton
  },
  props: {
    xmlDetailsData: {
      type: Object
    }
  },
  data () {
    return {
      isPopupActive: true,
      highlightedXmlData: '',
      mousedown: false,
      xmlData: ''
    }
  },
  watch: {
    xmlData: {
      handler () {
        if (this.xmlData.length > 0) {
          if (this.isXML(this.xmlData)) {
            const formattedXml = xmlFormatter(this.xmlData)
            this.highlightedXmlData = Prism.highlight(formattedXml, Prism.languages.xml)
          } else if (this.isJSON(this.xmlData)) {
            this.highlightedXmlData = Prism.highlight(JSON.stringify(JSON.parse(this.xmlData), null, 2), Prism.languages.json, 'json')
          } else {
            this.highlightedXmlData = this.xmlData
          }
        }
      },
      immediate: true // Appeler la méthode lors de la création du composant
    }
  },
  created () {
    window.addEventListener('resize', this.changeMaxHeightClient)
    window.addEventListener('mousedown', this.handleMouseDown)
    window.addEventListener('mouseup', this.handleMouseUp)
    this.xmlData = this.see(this.xmlDetailsData.data)
  },
  destroyed () {
    window.removeEventListener('resize', this.changeMaxHeightClient)
  },
  methods: {
    isXML (str) {
      try {
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(str, 'text/xml')
        return xmlDoc.documentElement.nodeName !== 'parsererror'
      } catch (e) {
        return false
      }
    },
    isJSON (str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    },
    changeMaxHeightClient () {
      let maxHeight = document.querySelector('body').clientHeight - 50
      document.querySelector('.modal-container').setAttribute('style', 'overflow-y:auto;max-height:' + maxHeight + 'px')
    },
    dontClose (e) {
      e.stopPropagation()
    },
    getMaxHeightClient () {
      return document.querySelector('body').clientHeight - 50
    },
    handleMouseDown (e) {
      if (!this.mousedown) {
        if (e.target.closest('.modal-mask') || e.target.closest('.close-button')) {
          this.$emit('close')
        }
        this.mousedown = true
      }
    },
    handleMouseUp (e) {
      this.mousedown = false
    },
    see (data) {
      data = data.substr(23)
      data = Buffer.from(data, 'base64') 
      data = data.toString()
      return data
    },
    download (data) {
      let extension = '.xml'
      if (this.isJSON(this.xmlData)) {
        extension = '.json'
      }
      const linkSource = data
      const downloadLink = document.createElement('a')
      const fileName = moment().format('YYYYMMDD_hhmmss_') + this.xmlDetailsData.type + extension
      downloadFileWithDefinedHeaders(this, fileName, data)
      this.$emit('close')
    }
  }
}
</script>
<style scoped>
.xmlPopup {
  max-height: 80%;
  padding: 1rem;
  overflow: hidden;
}

.break {
  /* word-break: break-all; */
}
</style>
